var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId,
    stroke: "#2329D6",
    strokeWidth: 1,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    fill: "none",
    color: "#2329D6",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "chatAltIconTitle"
  }, "Chat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "chatAltIconTitle"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "chatAltIconDesc"
  }, "Icon of a rectangular chat bubble")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13,17 L7,21 L7,17 L3,17 L3,4 L21,4 L21,17 L13,17 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAlt);
export default __webpack_public_path__ + "static/media/chat-alt.12953fe465f0938ec4f5ef40ab1e7570.svg";
export { ForwardRef as ReactComponent };